/**
 * Authoritative fare formula. Used for the rider's estimate and the server's
 * final settlement so the two never drift. All values are integer PKR.
 *
 *   fare = max(minFare, base + perKm * km + perMin * min) * surge
 */
export function calculateFare(config, distanceKm, durationMin, surgeMultiplier = 1) {
    if (distanceKm < 0 || durationMin < 0) {
        throw new RangeError('Distance and duration must be non-negative.');
    }
    if (surgeMultiplier < 1) {
        throw new RangeError('Surge multiplier cannot be less than 1.');
    }
    const distance = Math.round(config.perKm * distanceKm);
    const duration = Math.round(config.perMin * durationMin);
    const preSurge = Math.max(config.minFare, config.base + distance + duration);
    const total = Math.round(preSurge * surgeMultiplier);
    return {
        base: config.base,
        distance,
        duration,
        surge: total - preSurge,
        total,
    };
}
export function formatPkr(amount) {
    return `Rs ${amount.toLocaleString('en-PK')}`;
}
//# sourceMappingURL=fare.js.map